/* ============================================================
   Flamel Analytics — Theme dataLayer events
   Cliente: DUO Boutique PR (duoboutiquepr.com)
   Generated: 2026-05-25 by flamel-analytics-dept WF-ANA-003
   Spec ref: clients/duoboutiquepr/deliverables/2026-05-25/event-spec.json

   INSTALACIÓN CONDICIONAL — DEPENDE DEL AUDIT:
   Por cada evento (`view_item`, `add_to_cart`, etc.) — si el Flamel
   Shopify agent (ID 384a863cf9cf5bff8d26ee821795fadf) YA lo emite al
   dataLayer con shape GA4 estándar, COMENTAR la sección correspondiente
   abajo. Ver: flamel-agent-audit.md sección C.

   Si el agent NO emite ninguno → instalar este archivo completo:
   1. Subir a `assets/flamel-datalayer-events.js`
   2. En `layout/theme.liquid` antes del cierre </head> añadir:
      {{ 'flamel-datalayer-events.js' | asset_url | script_tag }}
   3. Asegurarse de que carga DESPUÉS del snippet de dataLayer init y del GTM snippet.

   ARQUITECTURA:
   - Eventos PDP/Collection se inyectan inline en sus respectivos templates
     (ver bloques de Liquid al final de este archivo, copiar a los templates).
   - Eventos de cart (add/remove/view) se interceptan via fetch monkey-patch
     y/o eventos custom del theme (cart:item-added, drawer:open).

   COMPATIBILIDAD: ES5+ — no dependencias externas. Funciona en Online Store 2.0
   (Dawn-based) y temas clásicos. No usa ES modules.
   ============================================================ */

(function() {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  /* Helper: push con reset previo del objeto ecommerce (Google recommended pattern) */
  function dlPush(eventName, ecommerce, extras) {
    window.dataLayer.push({ ecommerce: null });
    var payload = { event: eventName };
    if (ecommerce) payload.ecommerce = ecommerce;
    if (extras) {
      Object.keys(extras).forEach(function(k) { payload[k] = extras[k]; });
    }
    window.dataLayer.push(payload);
  }

  /* Helper: convierte cents (Shopify cart.js) a unidad principal (USD) */
  function fromCents(cents) {
    return typeof cents === 'number' ? cents / 100 : 0;
  }

  /* ========================================================
     1. ADD_TO_CART — intercept de /cart/add.js
     [CONDICIONAL] — comentar si Flamel agent ya emite add_to_cart
     ======================================================== */

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartAdd = url.indexOf('/cart/add') !== -1;
      var isCartChange = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;

      return originalFetch.apply(this, arguments).then(function(response) {
        if (!response.ok) return response;

        var clone = response.clone();
        clone.json().then(function(data) {
          try {
            if (isCartAdd && data && (data.id || data.items)) {
              var items = data.items || [data];
              var totalValue = 0;
              var ga4Items = items.map(function(it) {
                var price = fromCents(it.final_price || it.price || 0);
                var qty = it.quantity || 1;
                totalValue += price * qty;
                return {
                  item_id: String(it.product_id || it.id || ''),
                  item_name: it.product_title || it.title || '',
                  item_variant: it.variant_title || '',
                  item_brand: it.vendor || '',
                  item_category: it.product_type || '',
                  price: price,
                  quantity: qty
                };
              });

              dlPush('add_to_cart', {
                currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD',
                value: totalValue,
                items: ga4Items
              });
            } else if (isCartChange && data && typeof data.item_count === 'number') {
              /* Cambio de cantidad — si quantity llegó a 0, es remove */
              window.__flamelLastCartState = window.__flamelLastCartState || data.item_count;
              if (data.item_count < window.__flamelLastCartState) {
                fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
                  dlPush('remove_from_cart', {
                    currency: cart.currency || 'USD',
                    value: fromCents(cart.total_price)
                  });
                });
              }
              window.__flamelLastCartState = data.item_count;
            }
          } catch(e) {
            console.error('[Flamel] cart event push error:', e);
          }
        }).catch(function(){ /* swallow JSON parse errors */ });

        return response;
      });
    };
  }

  /* ========================================================
     2. ADD_TO_CART — eventos custom del theme (Dawn / Online Store 2.0)
     [CONDICIONAL] — comentar si Flamel agent ya emite add_to_cart
     ======================================================== */

  ['cart:item-added', 'product:added', 'product:added-to-cart'].forEach(function(eventName) {
    document.addEventListener(eventName, function(e) {
      try {
        var detail = e.detail || {};
        if (!detail.item && !detail.product) return;
        var item = detail.item || detail.product;
        var price = fromCents(item.final_price || item.price || 0);
        var qty = item.quantity || 1;
        dlPush('add_to_cart', {
          currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active ? window.Shopify.currency.active : 'USD',
          value: price * qty,
          items: [{
            item_id: String(item.product_id || item.id),
            item_name: item.product_title || item.title || '',
            item_variant: item.variant_title || '',
            price: price,
            quantity: qty
          }]
        });
      } catch(err) {
        console.error('[Flamel] add_to_cart custom event push error:', err);
      }
    });
  });

  /* ========================================================
     3. VIEW_CART — apertura del cart drawer
     [CONDICIONAL] — comentar si Flamel agent ya emite view_cart
     ======================================================== */

  ['drawer:open', 'cart:open', 'cart-drawer:opened'].forEach(function(eventName) {
    document.addEventListener(eventName, function() {
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
        if (!cart || !cart.items) return;
        var ga4Items = cart.items.map(function(it) {
          return {
            item_id: String(it.product_id || it.id),
            item_name: it.product_title || it.title || '',
            item_variant: it.variant_title || '',
            price: fromCents(it.final_price || it.price || 0),
            quantity: it.quantity || 1
          };
        });
        dlPush('view_cart', {
          currency: cart.currency || 'USD',
          value: fromCents(cart.total_price),
          items: ga4Items
        });
      }).catch(function(){ /* swallow */ });
    });
  });

  /* Cart page (/cart) — fire on render */
  if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart?') === 0) {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return;
      var ga4Items = cart.items.map(function(it) {
        return {
          item_id: String(it.product_id || it.id),
          item_name: it.product_title || it.title || '',
          price: fromCents(it.final_price || it.price || 0),
          quantity: it.quantity || 1
        };
      });
      dlPush('view_cart', {
        currency: cart.currency || 'USD',
        value: fromCents(cart.total_price),
        items: ga4Items
      });
    }).catch(function(){});
  }

  /* ========================================================
     4. SEARCH — submit del form de búsqueda
     [CONDICIONAL] — solo si la tienda tiene searchbar activa
     ======================================================== */

  function attachSearchListener() {
    var forms = document.querySelectorAll('form[action="/search"], form[action*="/search"]');
    forms.forEach(function(form) {
      if (form.__flamelAttached) return;
      form.__flamelAttached = true;
      form.addEventListener('submit', function() {
        var input = form.querySelector('input[name="q"]');
        var q = input ? (input.value || '').trim() : '';
        if (!q) return;
        dlPush('search', null, { search_term: q });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSearchListener);
  } else {
    attachSearchListener();
  }

  /* ========================================================
     5. VIEW_PROMOTION — IntersectionObserver sobre elementos con data-promo-id
     ======================================================== */

  if (typeof IntersectionObserver === 'function') {
    var promoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
        var el = entry.target;
        if (el.__flamelPromoFired) return;
        el.__flamelPromoFired = true;
        dlPush('view_promotion', {
          promotion_id: el.getAttribute('data-promo-id') || '',
          promotion_name: el.getAttribute('data-promo-name') || '',
          creative_name: el.getAttribute('data-promo-creative') || '',
          creative_slot: el.getAttribute('data-promo-slot') || '',
          location_id: el.getAttribute('data-promo-location') || '',
          items: []
        });
        promoObserver.unobserve(el);
      });
    }, { threshold: 0.5 });

    function attachPromoObserver() {
      document.querySelectorAll('[data-promo-id]').forEach(function(el) {
        promoObserver.observe(el);
        /* select_promotion en click */
        el.addEventListener('click', function() {
          dlPush('select_promotion', {
            promotion_id: el.getAttribute('data-promo-id') || '',
            promotion_name: el.getAttribute('data-promo-name') || '',
            creative_name: el.getAttribute('data-promo-creative') || '',
            creative_slot: el.getAttribute('data-promo-slot') || '',
            location_id: el.getAttribute('data-promo-location') || '',
            items: []
          });
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachPromoObserver);
    } else {
      attachPromoObserver();
    }
  }

})();

/* ============================================================
   ANEXO — Bloques Liquid para pegar en templates específicos
   ============================================================
   Estos bloques se inyectan en los templates correspondientes
   (no van en este JS — son snippets para Liquid).

   [CONDICIONAL] — comentar si Flamel agent ya emite view_item / view_item_list

   PEGAR EN: sections/main-product.liquid (o equivalente PDP)
   ANTES de cerrar la section principal, dentro de <script>:

   {% comment %} Flamel — view_item event {% endcomment %}
   <script>
   window.dataLayer = window.dataLayer || [];
   window.dataLayer.push({ ecommerce: null });
   window.dataLayer.push({
     event: 'view_item',
     ecommerce: {
       currency: '{{ cart.currency.iso_code | default: shop.currency }}',
       value: {{ product.price | divided_by: 100.0 }},
       items: [{
         item_id: '{{ product.id }}',
         item_name: {{ product.title | json }},
         item_brand: {{ product.vendor | json }},
         item_category: {{ product.type | json }},
         item_variant: {{ product.selected_or_first_available_variant.title | json }},
         price: {{ product.price | divided_by: 100.0 }},
         quantity: 1
       }]
     }
   });
   </script>

   ----

   PEGAR EN: sections/main-collection-product-grid.liquid
   (o template de colección) — DESPUÉS del loop de productos:

   {% comment %} Flamel — view_item_list event {% endcomment %}
   <script>
   window.dataLayer = window.dataLayer || [];
   window.dataLayer.push({ ecommerce: null });
   window.dataLayer.push({
     event: 'view_item_list',
     ecommerce: {
       item_list_id: '{{ collection.handle }}',
       item_list_name: {{ collection.title | json }},
       items: [
         {%- for product in collection.products limit: 24 -%}
         {
           item_id: '{{ product.id }}',
           item_name: {{ product.title | json }},
           item_brand: {{ product.vendor | json }},
           item_category: {{ product.type | json }},
           price: {{ product.price | divided_by: 100.0 }},
           index: {{ forloop.index0 }}
         }{% unless forloop.last %},{% endunless %}
         {%- endfor -%}
       ]
     }
   });

   // select_item — delegated click sobre product cards
   document.querySelectorAll('[data-product-card]').forEach(function(card){
     card.addEventListener('click', function(){
       window.dataLayer.push({ ecommerce: null });
       window.dataLayer.push({
         event: 'select_item',
         ecommerce: {
           item_list_id: '{{ collection.handle }}',
           item_list_name: {{ collection.title | json }},
           items: [{
             item_id: card.getAttribute('data-product-id'),
             item_name: card.getAttribute('data-product-title')
           }]
         }
       });
     });
   });
   </script>

   Si los product cards no tienen data-attributes, añadirlos en el card snippet:
     <div class="product-card" data-product-card
          data-product-id="{{ product.id }}"
          data-product-title="{{ product.title | escape }}">

   ============================================================
*/
